import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Reply Support Ticket Request Schema
 * POST /api/v2/support/tickets/:ticketId/reply
 */ export const ReplySupportTicketRequestSchema = z.object({
    body: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED).max(5000)
});
/**
 * Reply Support Ticket Response Schema
 */ export const ReplySupportTicketResponseSchema = z.object({
    messageId: z.number()
});

//# sourceMappingURL=reply-support-ticket.schema.js.map